import { FulfillmentGroupCsvColumn } from "@redotech/redo-fulfillment-common/csv-column";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { getExpandedItems } from "./fulfillment-group-csv-utils";

const variantCustomStringKeys = [
  "variantCustomString1",
  "variantCustomString2",
  "variantCustomString3",
] as const;

export function getVariantCustomStringCsvColumn(
  title: string,
  key: (typeof variantCustomStringKeys)[number],
): FulfillmentGroupCsvColumn<FulfillmentGroupData> {
  return {
    header: title,
    cell: (row: FulfillmentGroupData) => {
      const values = new Set<string>();
      for (const item of getExpandedItems(row)) {
        const value = item[key];
        if (value) {
          values.add(value);
        }
      }
      return values.size > 0 ? Array.from(values).join(", ") : "";
    },
    expandedCsvCell: (row: FulfillmentGroupData, expansionIndex: number) => {
      const lineItem = getExpandedItems(row)?.[expansionIndex];
      return lineItem?.[key] || "";
    },
  };
}
